import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SpecialRequestId = Brand<number, 'SpecialRequestId'>;
export const SpecialRequestId = createBranded<SpecialRequestId>();